import React, { forwardRef, } from 'react';
import { CnDetailInfo as UICnDetailInfo } from '@cainiaofe/cn-ui-m';
import { batchCalculateTextExprValue, isDesignMode, mergeHandleProps2 } from '@/common/util/util';
import { dataOriginStatic } from '@/common/util/const';
import isPlainObject from 'lodash/isPlainObject';
const CnDetailInfo = forwardRef((props, ref) => {
    if (!UICnDetailInfo) {
        return null;
    }
    let extraProps = {};
    const { dataOrigin, staticInfo, _context } = props;
    if (dataOrigin === dataOriginStatic && isPlainObject(staticInfo)) {
        extraProps = {
            ...batchCalculateTextExprValue(staticInfo, {
                recordDataSource: {},
                state: _context?.state,
            }),
        };
    }
    const isDesign = isDesignMode(props);
    extraProps = mergeHandleProps2({
        handleProps: props?.handleProps,
        componentProps: extraProps,
        _context: props?._context,
    });
    return React.createElement(UICnDetailInfo, { ...extraProps });
});
CnDetailInfo.displayName = 'CnDetailInfo';
export default CnDetailInfo;
